import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {fas} from "@fortawesome/free-solid-svg-icons";
import {far} from "@fortawesome/free-regular-svg-icons";
import {FaIconLibrary} from "@fortawesome/angular-fontawesome";
import {FieldsRegistryService} from "./components/common/fields/fields-registry.service";
import {SelectBadgeFieldComponent} from "./components/common/fields/select-badge-field/select-badge-field.component";
import {EditorFieldComponent} from "./components/common/fields/editor-field/editor-field.component";
import {AlertFieldComponent} from "./components/common/fields/alert-field/alert-field.component";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [
        RouterOutlet
    ],
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'portail-frontend';

  constructor(private router: Router, library: FaIconLibrary, fieldsRegistry: FieldsRegistryService) {
    // Add an icon to the library for convenient access in other components
    library.addIconPacks(fas, far);
    // Register custom fields types
    fieldsRegistry.registerFieldType('select2', SelectBadgeFieldComponent);
    fieldsRegistry.registerFieldType('editor', EditorFieldComponent);
    fieldsRegistry.registerFieldType('alert', AlertFieldComponent);
  }

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
